import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Question from '../Question';
import CheckboxOption from '../CheckboxOption';

class DependentCheckboxQuestions extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            activeQuestions: {}
        };
    }

    // Toggles the 'isChecked' flag
    handleClick = (optionObject) => {
        let activeQuestions = this.state.activeQuestions;
        if (optionObject.check) {
            activeQuestions['child-' + optionObject.value] = true
        }
        else {
            activeQuestions['child-' + optionObject.value] = false
        }

        this.setState({
            activeQuestions: activeQuestions
        });
    }

    // Returns true or false if the current questionid is present in activeQuestions
    showHideQuestion = (questionid) => {
        return this.state.activeQuestions[questionid] ?? false;
    }

    // Given `options` and a linking questionid, generates <CheckboxOption>s
    generateCheckboxes = (checkboxArray, questionid) => {
        return (
            checkboxArray.map(item => {
                return (
                    <CheckboxOption
                        type="checkbox"
                        name={questionid + '-' + item.value}
                        id={questionid + '-' + item.value}
                        questionid={questionid}
                        value={item.value}
                        optionLabel={item.label}
                        key={questionid + '-' + item.value}
                        onChangeFunction={this.handleClick}
                    />
                )
            })
        )
    }

    // Parent/controlling set of checkboxes
    createInput = (isParent, options, questionProperties) => {
        let id = questionProperties.id;
        if (!isParent) {
            id = "child-" +  questionProperties.id;
        }

        return (
            <Question
                id={id}
                key={id}
                stepid={this.props.stepid}
                type="checkbox"
                mandatory
                label={questionProperties.label}
                hintText={questionProperties.hintText}
                showError={this.props.showError}
                existingAnswer={questionProperties.existingAnswer}
                returnQuestionData={this.props.returnQuestionData}
                removeQuestionData={questionProperties.removeQuestionData}
                show={!isParent ? this.showHideQuestion(id) : this.props.show}>

                {this.generateCheckboxes(options, id)}
            </Question>
        )
    }

    getChildAnswer = (id) => {
        let existingAnswer;

        if (this.props.childExistingAnswers && this.props.childExistingAnswers.length > 0) {
            existingAnswer = this.props.childExistingAnswers.find(question => question.id === id);
            
            if (existingAnswer) {
                return existingAnswer.answer
            }
            return null
        }
        return null
    }

    // Child/dependent set of checkboxes (if parent has `options`)
    createChildrenInput = (parentCheckboxOptions, questionPropertiesParams) => {
        return (
            parentCheckboxOptions.map((option) => {
                if (option.options) {
                    let questionPropertiesUpdated = {
                        id: option.value, 
                        label: option.label + ' exclusion codes', 
                        hintText: this.props.hintText,
                        existingAnswer: this.getChildAnswer("child-" + option.value),
                        removeQuestionData: questionPropertiesParams.removeQuestionData
                    };
                    return (this.createInput(false, option.options, questionPropertiesUpdated));
                }
                return null;
            })
        )
    }

    render() {
        return (
            <Fragment>                
                {this.createInput(true, this.props.options, {
                    id: this.props.id, 
                    label: this.props.label, 
                    hintText: this.props.hintText,
                    removeQuestionData: this.props.removeQuestionData,
                    existingAnswer: this.props.existingAnswer
                })}
                {this.createChildrenInput(this.props.options, {
                    removeQuestionData: this.props.removeQuestionData,
                    existingAnswer: this.props.childExistingAnswers
                })}
            </Fragment>
        )
    }
}

DependentCheckboxQuestions.defaultProps ={
    show: true,
}

DependentCheckboxQuestions.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    hintText: PropTypes.string,
    options: PropTypes.array,
    removeQuestionData: PropTypes.func,
    existingAnswer: PropTypes.object,
    childExistingAnswers: PropTypes.array,
    show: PropTypes.bool,
    stepid: PropTypes.string,
    showError: PropTypes.bool,
    returnQuestionData: PropTypes.func
}

export default DependentCheckboxQuestions;